module.exports = {
  locales: ["de"],
  defaultLocale: "de",
  pages: {
    "*": ["common"],
  },
}
